export const SET_PROFILE = "setProfile";
export const SET_ACCESS_TOKEN = "setAccessToken";
export const CLEAN_AUTH = "cleanAuth";
